export const service_category = {
  FETCH_SERVICE_CATEGORIES_LOADING: 'FETCH_SERVICE_CATEGORIES_LOADING',
  FETCH_SERVICE_CATEGORIES_SUCCESS: 'FETCH_SERVICE_CATEGORIES_SUCCESS'
};
